export default __webpack_public_path__ + "static/media/product_3.2.ebcb16b5.jpg";